import { generateVirtualMeta, DEFAULT_VALUE } from './main.tsx';

export const virtualiserActions = {
	generateVirtualMeta,
} as const;

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { DEFAULT_VALUE };
